import { useState } from 'react';
import { ChangePasswordModal } from 'frontend-container/components/Menu/components/ChangePasswordModal/ChangePasswordModal';
import { MainMenuInfotip } from 'frontend-container/components/Menu/components/MainMenuInfotip/MainMenuInfotip';
import { UserInfotipBody } from 'frontend-container/components/Menu/components/User/components/UserInfotipBody';
import { UserInfotipHeader } from 'frontend-container/components/Menu/components/User/components/UserInfotipHeader';
import { UserTrigger } from 'frontend-container/components/Menu/components/User/components/UserTrigger';
import { userService } from 'frontend-container/components/Menu/components/User/service';
import { UserPreferencesModal } from 'frontend-container/components/Menu/components/User/UserPreferences/UserPreferencesModal/UserPreferencesModal';
import { shouldUseNewMenu } from 'frontend-container/components/Menu/service';

const menuId = 'menu-logged-user';

export const User = (): JSX.Element => {
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [isUserPreferencesModalOpen, setIsUserPreferencesModalOpen] =
    useState(false);
  const { userDetails, department, jobTitle } =
    userService.getFullCurrentUser() ?? {};

  const useNew = shouldUseNewMenu();

  const togglePasswordModal = (): void => {
    setIsPasswordModalOpen(!isPasswordModalOpen);
  };

  const toggleUserPreferencesModal = (): void => {
    setIsUserPreferencesModalOpen(!isUserPreferencesModalOpen);
  };

  return (
    <>
      <MainMenuInfotip
        componentId={menuId}
        additionalContainerClass={`${
          useNew ? 'ac-spacing-left-lg' : ''
        } ac-spacing-right-md`}
        triggeringComponent={
          <UserTrigger
            firstName={userDetails.personalData?.firstName}
            lastName={userDetails.personalData?.lastName}
          />
        }
        headerComponent={
          <UserInfotipHeader
            firstName={userDetails.personalData?.firstName}
            lastName={userDetails.personalData?.lastName}
            email={userDetails.email}
            department={department}
            jobTitle={jobTitle}
          />
        }
        bodyComponent={
          <UserInfotipBody
            togglePasswordModal={togglePasswordModal}
            toggleUserPreferencesModal={toggleUserPreferencesModal}
          />
        }
      />
      {isPasswordModalOpen && (
        <ChangePasswordModal
          onClose={togglePasswordModal}
          onConfirm={togglePasswordModal}
        />
      )}
      {isUserPreferencesModalOpen && (
        <UserPreferencesModal onClose={toggleUserPreferencesModal} />
      )}
    </>
  );
};
